<template>
    <header class="text-center mb-4">
        <div v-if="showBanner" class="hl-banner mb-5">
            <p>Read the information below or call us on 0117 314 1798 to find out more and have your questions answered by a specialist.</p>
        </div>
        <h2 class="skin-page-heading">{{ title }}</h2>
        <h4 v-if="subTitle" class="col-sm-6 mx-auto">{{ subTitle }}</h4>
    </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
    title: { default: "" },
    subTitle: { default: "" }
});

const store = useStore();

const showBanner = computed<boolean>(() => store.state.configuration.guiidePlusShowHeaderBanner);

</script>

<style scoped>
    .hl-banner {
        position: relative;
        width: 100%;
        height: 250px;
        background: url("/Content/images/HL/hl-workplace-banner.jpg") no-repeat 50% 50%;
        background-size: cover;
    }

        .hl-banner > p {
            width: 45%;
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 15px 0 0 15px;
            color: #fff !important;
            font-size: 20px !important;
            text-align: left;
        }

    @media (max-width: 576px) {
        .hl-banner > p {
            width: 100%;
        }
    }
</style>